
































































import {Vue, Component, Prop, Ref, Watch} from "vue-property-decorator"
import {Getter, Mutation} from "vuex-class";
import GenericTemplate from "@/pages/Pages/Templates/GenericTemplate.vue";
import {FormRowWings, TextareaWings} from "wings-ui-components";
import {MsgTransports} from "@/store/types";
import {WhatsAppTemplateItemImpl} from "@/store/templates/types";
import {Route} from "vue-router";
import {cloneDeep} from "lodash";

Component.registerHooks(["beforeRouteLeave"]);

@Component({components: {GenericTemplate, FormRowWings, TextareaWings}})
export default class WhatsappTemplate extends Vue {
  @Ref("genericTemplate") genericTemplate!: GenericTemplate;
  @Prop({default: null}) distribution: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  private transport = MsgTransports.WHATSAPP;
  private templateObject = new WhatsAppTemplateItemImpl();

  created() {
    this.setTemplate()
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.setTemplate()
    }
  }

  setTemplate() {
    this.setTemplateObject(cloneDeep(this.templateObject))
  }

  onLoadTemplate(template: any) {
    this.$emit('onLoadTemplate', template)
  }

  beforeRouteLeave(to: Route, from: Route, next: any) {
    this.genericTemplate.beforeLeave(to, from, next);
  }
}
